import { z } from 'zod';

// if you want to use it as a typescript interface
// z.infer<typeof employeeMiniProfile>
export const employeeMiniProfile = z.object({
  id: z.number(),
  displayName: z.string().nullable(),
  profilePhoto: z.string().nullable(),
  designation: z.string().nullable(),
  ownerType: z.enum(['OWNER', 'COLLABORATOR']).nullable(),
  employeeFunction: z.string().nullable(),
  email: z.string().nullable(),
  participantEmail: z.string().nullable().optional(),
});
